// Configuration dynamique selon l'environnement
const getApiBaseUrl = () => {
  // Local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost/argan-shop/api';
  }
  // Production : URL complète de ton API
  return 'https://d4unaturally.com/api'; // <-- mettre ton API réelle
};



const API_BASE_URL = getApiBaseUrl();

const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = `${API_BASE_URL}${endpoint}`;
    console.log(`🔄 API Call: ${url}`); // Debug
    
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API Error:', error);
    console.error('URL attempted:', `${API_BASE_URL}${endpoint}`);
    throw error;
  }
};

export const apiService = {
  test: () => apiRequest('/test.php'),

  checkTables: () => apiRequest('/check-tables.php'),
  
  getAllProducts: () => apiRequest('/products-all.php'),
  
  getProductsByGender: (gender) => 
    apiRequest(`/products-gender.php?gender=${gender}`),
  
  getProductById: (id) => 
    apiRequest(`/products.php?id=${id}`),
  
  getFeaturedProducts: () => 
    apiRequest('/products.php?featured=1'),
  
  getProductsByCategory: (categoryId) => 
    apiRequest(`/products.php?category=${categoryId}`),

  getOrganizedCategories: (gender) => 
    apiRequest(`/categories-organized.php?gender=${gender}`),
  
  getProductsByCategoryType: (gender, categoryType) => 
    apiRequest(`/products-category-type.php?gender=${gender}&type=${categoryType}`),

  getCategoriesWithProducts: () => apiRequest('/categories-with-products.php'),
};